import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { CompareType } from '@/components/ui/charts/types'
import { EChartsOption } from 'echarts'

type MasterChartData = {
  branchNames: string[]
  startDate: string
  endDate: string
  interval: string
  dataName: string
  type?: CompareType
  value?: string
}

export const getMasterChartData = async ({
  branchNames,
  startDate,
  endDate,
  interval = 'day',
  dataName,
  type,
  value,
}: MasterChartData): Promise<EChartsOption[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/master-chart/`, {
      params: {
        branch_names: branchNames.join(','),
        start_date: startDate,
        end_date: endDate,
        interval,
        type,
        value,
        data_name: dataName,
      },
    })

    return response.data
  } catch (error) {
    console.error('Error fetching chart metrics:', error)
    throw error
  }
}
